import type { MailContentProps, MailMetadata } from "../../lib/types";
import { calculateDateWithDateRelative } from "../../lib/utils";
import { MailSignature } from "../mail/mail-signature";

function InvitationConferenceGrguNancy({ variablesData }: MailContentProps) {
  return (
    <div className="space-y-2">
      <p>
        Dans le cadre de l'Université, le Groupe de Recherche en Gestion de
        l'Université vous prie de bien vouloir honorer de votre présence le{" "}
        {calculateDateWithDateRelative(
          Number(variablesData.conference_grgu_date) || 0,
        )}{" "}
        à 9h00 au palais des congrès de NANCY la conférence de{" "}
        <span className="underline">
          {variablesData.genre_masc_complet}{" "}
          {variablesData.conference_grgu_conferencier_prenom}{" "}
          {variablesData.conference_grgu_conferencier_nom}
        </span>
        , {variablesData.conference_grgu_conferencier_fonction} , sur le thème :
      </p>
      <div className="text-center">
        <h1 className="font-bold">
          LA RESPONSABILITE SOCIALE DE L'ENTREPRISE :
        </h1>
        <h2 className="font-bold">REALITE, MYTHE OU MYSTIFICATION ?</h2>
        <p className="font-bold">DROITS D'INSCRIPTION : 140 €</p>
        <p>(Conférence suivie d'un cocktail)</p>
        <p>
          * tarif réduit pour les demandeurs d'emploi, les seniors n'exerçant
          plus d'activité professionnelle et les étudiants :{" "}
        </p>
        <p className="font-bold">40 €</p>
        <p>INSCRIPTION SUR LE SITE : </p>
        <a href="http://www.conferenceuniv.fr/">www.conferenceuniv.fr</a>
        <p>INFORMATION AUPRÈS DE :</p>
        <p>
          {variablesData.genre_fem_complet}{" "}
          {variablesData.conference_grgu_emetteur_invitation_prenom}{" "}
          {variablesData.conference_grgu_emetteur_invitation_nom}
        </p>
        <p>C.R.G.U. Nancy2 13 rue Joachim Murat 54 000 Nancy </p>
        <p>Tel. 03 83 34 64 23 </p>
        <p>{variablesData.conference_grgu_emetteur_invitation_mail}</p>
        <p className="font-bold">
          Journée du{" "}
          {calculateDateWithDateRelative(
            Number(variablesData.conference_grgu_date) || 0,
          )}
        </p>
      </div>
      <MailSignature
        emetteurLogo={InvitationConferenceGrguNancy.metadata.emetteurLogo}
        emetteur={InvitationConferenceGrguNancy.metadata.emetteur}
        emetteurPoste={InvitationConferenceGrguNancy.metadata.emetteurPoste}
        emetteurEntreprise={
          InvitationConferenceGrguNancy.metadata.emetteurEntreprise
        }
      />
    </div>
  );
}

InvitationConferenceGrguNancy.metadata = {
  titre: "Invitation Conférence Université",
  cleMail: "invitation_conference_grgu_Nancy",
  messageTransfert: false,
  emetteur: "Université",
  emetteurPoste: "",
  emetteurEntreprise: "",
  emetteurLogo: null,
  dateRelative: 0,
  piecesJointes: [],
} as MailMetadata;

export default InvitationConferenceGrguNancy;
